module.exports = __webpack_public_path__ + "static/NLGP-Favicon-dde6b953957e9d32abbd078a58fd3b00.ico";